'use client';

import { useEffect } from 'react';

import { useEssentials } from '@wix/fe-essentials/react';

import { AppErrorFallback } from '@/components/ErrorBoundary/AppErrorFallback';

type ErrorPageProps = {
  error: Error & { digest?: string };
  reset: () => void;
};

export default function ErrorPage({ error }: ErrorPageProps) {
  const { errorMonitor } = useEssentials();

  useEffect(() => {
    errorMonitor.captureException(error);
  }, [error, errorMonitor]);

  return (
    <AppErrorFallback
      title="We hit a technical issue"
      description="Something unexpected happened while loading this page. Please try again."
      onAction={() => window.location.reload()}
    />
  );
}
